import {
  TRAILER_TAIL_TYPE_ALL,
  TRAILER_TAIL_TYPE_GET,
  TRAILER_TAIL_TYPE_POST,
  TRAILER_TAIL_TYPE_PUT,
  TRAILER_TAIL_TYPE_DEL,
  TRAILER_TAIL_TYPE_LOADING,
  TRAILER_TAIL_TYPE_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const trailerTailTypeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: TRAILER_TAIL_TYPE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/trailer-tail-type`,
      {
        ...payload,
      },
    );
    dispatch({ type: TRAILER_TAIL_TYPE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TRAILER_TAIL_TYPE_ERROR });
  }
};

export const trailerTailTypeAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = null, page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/trailer-tail-type?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: TRAILER_TAIL_TYPE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TRAILER_TAIL_TYPE_ERROR });
  }
};

export const trailerTailTypeGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/trailer-tail-type/${id}`,
    );
    if (status === 200) {
      dispatch({ type: TRAILER_TAIL_TYPE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TRAILER_TAIL_TYPE_ERROR });
  }
};

export const trailerTailTypePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: TRAILER_TAIL_TYPE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/trailer-tail-type/${id}`,
      payload,
    );
    dispatch({ type: TRAILER_TAIL_TYPE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TRAILER_TAIL_TYPE_ERROR });
  }
};

export const trailerTailTypeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: TRAILER_TAIL_TYPE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/trailer-tail-type/${id}`,
    );
    dispatch({ type: TRAILER_TAIL_TYPE_DEL, payload: data });
  } catch (error) {
    const { status } = error.request;
    console.error(error);

    if (status === 403) {
      const message = 'ไม่สามารถลบข้อมูลเนื่องจากยังคงมีข้อมูลอยู่ในหมวดหมู่';
      dispatch({ type: TRAILER_TAIL_TYPE_ERROR, payload: { message } });
      throw new Error(message);
    } else {
      const message = 'เกิดข้อผิดพลาด';
      dispatch({ type: TRAILER_TAIL_TYPE_ERROR, payload: { message } });
      throw new Error(message);
    }
  }
};
